export enum FooterType {
    Basic = "Basic",
    OneStepBasic ="OneStepBasic",
    OneStep = "OneStep",
    Default = "Default",
    SecondaryBrand = "SecondaryBrand",
    SecondaryBrandFunnels = "SecondaryBrandFunnels",
    Upsell = "Upsell",
    MemberPortalFinsights = "MemberPortalFinsights",
    Footer1087 = "Footer1087",
}